import Router from "vue-router";
import router from "@/router";

export default {
  clear_business({ commit }) {
    let business = {
      b2bEmployees: [],
      currentCompany: undefined,
      companyProfiles: [],
      companyProfile: undefined,
    };
    commit('set_business', business);
  },
  pop_business_employee({ commit }) {
    commit('pop_business_employee');
  },
  put_business_employee({ commit }, businessEmployee) {
    commit('put_business_employee', businessEmployee);
  },
  set_assigned_companies({ commit }, companies) {
    commit('set_assigned_companies', companies);
  },
  set_company_profile({ commit }, companyProfile) {
    commit('set_company_profile', companyProfile);
  },
  set_company_profile_employees({ commit }, employees) {
    commit('set_company_profile_employees', employees);
  },
  set_company_profile_leads({ commit }, leads) {
    commit('set_company_profile_leads', leads);
  },
  set_company_profile_positions({ commit }, positions) {
    commit('set_company_profile_positions', positions);
  },
  set_leads_summary({ commit }, leadsSummary) {
    commit('set_leads_summary', leadsSummary);
  },
  set_token({ commit }, token) {
    commit("set_token", token);
  },
  set_user({ commit }, user) {
    commit("set_user", user);
  },
  set_loading({ commit }, status) {
    commit("set_loading", status);
  },
  set_data({ commit }, name, data) {
    commit("set_data", name, data);
  },
  set_realoadRoutes() {
    const createRouter = () =>
      new Router({
        routes: router.options.getRoutes()
      });
    const newRouter = createRouter();
    router.matcher = newRouter.matcher;
  },
  update_lead({ commit}, lead) {
    commit('update_lead', lead);
  }
};
